import React from "react";
import styles from "./Sidebar.module.css";

function Sidebar({ step, setStep }) {
  const menuItems = [
    { id: 1, label: "Applicants" },
    { id: 2, label: "Property" },
    { id: 3, label: "Income & Expenses" },
    { id: 4, label: "Assets & Liabilities" },
    { id: 5, label: "Workshop Your Deal" },
  ];

  return (
    <div className={styles.sidebar}>
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={`${styles.menuItem} ${step === item.id ? styles.active : ""}`}
          onClick={() => setStep(item.id)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}

export default Sidebar;
